import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeNavLabel, containsHtmlContent } from '../utils/navItemUtils';

/**
 * NavItemLabel — renders a nav item label safely.
 * Plain-text labels render as text nodes; HTML labels are sanitized and
 * rendered with dangerouslySetInnerHTML.
 *
 * @param {Object} props
 * @param {string} props.label - The label string (may contain HTML)
 * @param {string} [props.className] - Optional className for the span
 */
const NavItemLabel = ({ label, className = '' }) => {
	if (!label || !label.trim()) return null;
	// Match HTML tags or HTML entities (named, decimal &#161;, hex &#xA1;).
	const isHtml = containsHtmlContent(label);
	if (isHtml) {
		const sanitized = sanitizeNavLabel(label);
		if (!sanitized) return null;
		return (
			<span
				className={className}
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{ __html: sanitized }}
			/>
		);
	}
	return <span className={className}>{label}</span>;
};

NavItemLabel.propTypes = {
	label: PropTypes.string.isRequired,
	className: PropTypes.string
};

export default NavItemLabel;
